import React, { useState } from "react";
import Footer from "../Footer/Footer";
import Banner from "../Sections/Blog/Banner/Banner";
import Header from "../Sections/Blog/Header/Header";
import Post from "../Sections/Blog/Post/Post";
import Listing from "../Sections/Blog/Posts/Listing";
import FreeApp from "../Sections/Download/FreeApp";
const Blog = () => {
  return (
    <>
      <Header></Header>
      <Banner></Banner>
      <Post></Post>
      <Listing></Listing>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Blog;
